import { useApiData } from '../useApiData';
import { setUserList } from 'store/userList/actions';

export const useUserListApi = () => {
    useApiData('/users/list', setUserList);
};
